Apt.fn.extend('maps', {}, {
	/**
	 * Add scale control
	 */
	addScale() {
		const scope = this;

		if (scope.scaleControl) {
			return;
		}

		scope.scaleControl = new maplibregl.ScaleControl({
			maxWidth: 110,
			unit: 'imperial'
		});

		scope.map.addControl(scope.scaleControl);
	}
});